enum Route {
  BASE = '/',
  LOGIN = '/login',
  SIGNUP = '/signup',
  MOVIE = '/movie',
  TV = '/tv',
  PERSON = '/person',
  PROFILE = '/profile',
  FAVORITES = '/favorites',
}

export default Route;
